<template>
  <div :class="`read-file-box ${disabled ? 'is-disabled' : ''}`">
    <input
      ref="fileReader"
      type="file"
      name="file"
      class="input-file"
      accept=".json,.geojson"
      :disabled="disabled"
      @click="handleUploadBtn"
      @change="handleFileChange"
    />
    <el-button
      size="small"
      class="file-upload-btn hollowOut-btn"
      :type="`${isLoading ? 'primary' : 'default'}`"
      :disabled="disabled"
      @click="handleBtnClick"
    >
      <div class="icon-box" v-if="isLoading">
        <icon-svg icon-class="ic-a-anniuloading-013" />
      </div>
      <span>导入区域文件</span>
    </el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      fileReader: null,
    };
  },
  props: {
    disabled: Boolean,
    handleUploadBtn: Function,
    onFileLoaded: Function,
  },
  mounted() {
    this.reader = new FileReader();
    this.reader.addEventListener("load", this.onReaderLoad);
  },
  destroyed() {
    this.reader.removeEventListener("load", this.onReaderLoad);
    this.reader = null;
  },
  methods: {
    handleBtnClick() {
      let domRef = this.$refs.fileReader;
      domRef.click();
    },
    handleFileChange() {
      let domRef = this.$refs.fileReader;
      let files = domRef.files;
      const file = files[0];

      if (!file) {
        this.$message.error("请选择文件");
        return;
      }

      if (!this.isValidFileType(file)) {
        // prettier-ignore
        this.$message.error("导入失败，该文件格式错误(仅支持json，geoJson两种格式文件)");
        return;
      }

      this.isLoading = true;
      this.reader.readAsText(file);
    },
    onReaderLoad(e) {
      try {
        const jsonData = JSON.parse(e.target.result);
        if (this.onFileLoaded) {
          this.onFileLoaded(jsonData);

          let domRef = this.$refs.fileReader;
          domRef.value = "";

          this.isLoading = false;
        }
      } catch (error) {
        this.onFileLoaded(null);

        let domRef = this.$refs.fileReader;
        domRef.value = "";

        this.isLoading = false;
        console.log(error.message);
        this.$message.error("读取文件时出错");
      }
    },
    isValidFileType(fileInfo) {
      let fileName = fileInfo.name;
      let fileType = fileName.substring(fileName.lastIndexOf(".") + 1);
      fileType = fileType.toLowerCase();

      const validFileTypes = ["json", "geojson"];

      let isValid = true;
      if (!validFileTypes.includes(fileType)) {
        isValid = false;
      }

      return isValid;
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.read-file-box {
  position: relative;
  height: 100%;
  margin-right: 10px;
  overflow: hidden;
  //   cursor: pointer;

  .file-upload-btn {
    position: relative;
    margin-right: 0px;
    border-radius: 4px;
    z-index: 1;

    > :deep(span) {
      display: flex;
      align-items: center;
    }
  }

  input[disabled="disabled"] {
    cursor: not-allowed !important;
  }

  input[type="file"] {
    position: absolute; //设置为绝对定位，不会影响到其他元素
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
    font-size: 0; // 防止cursor属性失效
    opacity: 0; //透明度为0
    filter: alpha(opacity=0);
    cursor: pointer;
    z-index: 0;
  }
}

.is-disabled {
  opacity: 0.8;
  cursor: not-allowed;
}
.icon-box {
  display: inline-block;
  margin: 0px 5px 0px -5px;
  animation: rotating 1s linear infinite;

  :deep(.svg-icon) {
    color: var(--base-primary-bgColor);
  }
}
</style>